/**
 * eBoutique API
 * eBoutique API
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export class EBTransactionAbstract {
  creationDate?: string;
  recordCreatorUserID?: string;
  transactionAmount?: number;
  effectiveDate?: string;
  servicerNumber?: string;
  disbursementDate?: string;
  glPostingDate?: string;
  reversalFlag?: boolean;
  fannieMaeLoanNumber: string;
  lastUpdatedUserId: string;
  appCode: string;
  transactionCd?: string;
}
